var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.initialized)?_c('div',{attrs:{"id":"wrapper"}},[(_vm.is('guest') && ! _vm.can('write') && ! _vm.can('read') && ! _vm.can('upload'))?_c('Login'):_c('div',{attrs:{"id":"inner"}},[_c('router-view')],1),_c('IdleLogout')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }